<template>
  <div class="local-container">
    <svg ref="svgEmbedded" class="chart"></svg>
    <div v-if="loading && showgraph()" class="loading-container">
      <v-progress-circular class="loading-sign" :size="50" color="#808080" indeterminate></v-progress-circular>
    </div>
    <div v-if="!loading" class="legend">
      <div class="header">
        Groups
        <v-spacer></v-spacer>

        <a v-if="this.selectAll" @click="alterSelection()">Deselect all</a>
        <a v-else @click="alterSelection()">Select all</a>
      </div>
      <v-checkbox v-model="$store.state.graphs.futureLoadCheckBoxes.B" class="px-3 py-0" label="Blue" :color="colorMapper.B" @change="updateGraph()" hide-details></v-checkbox>
      <v-checkbox v-model="$store.state.graphs.futureLoadCheckBoxes.O" class="px-3 py-0" label="Orange" :color="colorMapper.O" @change="updateGraph()" hide-details></v-checkbox>
      <v-checkbox v-model="$store.state.graphs.futureLoadCheckBoxes.I" class="px-3 py-0" label="Indigo" :color="colorMapper.I" @change="updateGraph()" hide-details></v-checkbox>
      <v-checkbox v-model="$store.state.graphs.futureLoadCheckBoxes.M" class="px-3 py-0" label="Maroon" :color="colorMapper.M" @change="updateGraph()" hide-details></v-checkbox>
      <v-checkbox v-model="$store.state.graphs.futureLoadCheckBoxes.A" class="px-3 py-0" label="Aqua" :color="colorMapper.A" @change="updateGraph()" hide-details></v-checkbox>
      <v-checkbox v-model="$store.state.graphs.futureLoadCheckBoxes.P" class="px-3 py-0" label="Pink" :color="colorMapper.P" @change="updateGraph()" hide-details></v-checkbox>

      <div class="synced-legend">
        <div v-if="syncedGraph" class="synced">

         <div  class="synced-color"></div>
      <span class="font-weight-light" style="font-size: 16px; padding-left:45px; color: rgba(0,0,0,.6); position:absolute; padding-top: 11px;">
       Synced Graph
    </span>
        </div>
        <div v-else class="desynced">
     <div class="desynced-color"></div>
      <span class="font-weight-light" style="font-size: 16px; padding-left:45px; color: rgba(0,0,0,.6); position:absolute; padding-top: 11px;">
       Desynced Graph
    </span>
      </div>

        </div>
    

    </div>
  </div>
</template>

<script>
import * as d3 from "d3";

export default {
  name: "LineChart",
  components: {},
  data: () => ({
    transform: null,
    selection: null,
    selectAll: true,
    colorMapper: { B: "#00A1FF", O: "#FEAE00", I: "#004D80", M: "#A33D32", A: "#16E7CF", P: "#FF42A1" },
    focusPaths: {},
    contextPaths: {},
    updateDomain: null,
    loading: true,
    resizeFunction: null,
    maxZoom: 100,
    brush: null,
    zoom: null,
    x: null,
    xAxis: null,
    margin: { top: 40, right: 230, bottom: 75, left: 100, between: 50 },
    coupledWithGantt: true,
    duration: 300,
    zoomedFunction: null,
    brushedFunction: null,
    lastZoomError: 0,
    lastBrushError: 0,
    syncedGraph: true,
    lastUpdated: null,
    latestUpdatedHour: -1,
    futureloadData: null,
  }),
  props: {
    id: { type: String, required: true },
    waitForLoad: { type: Boolean, required: false, default: false },
  },
  methods: {
    async updateData(forceUpdate ){
      if(this.$store.state.simulator.hoursPassed == this.latestUpdatedHour && !forceUpdate){
        return;
      }
      
      var data = await this.requestFutureloadData();
      this.latestUpdatedHour = this.$store.state.simulator.hoursPassed;

      this.futureloadData = data;

      var formattedData = this.formatData(this.futureloadData);
      formattedData.forEach((dataLine) => {
        var currLine = d3.select(".focusEmbedded").select(".line" + dataLine.key).datum(dataLine.value);
      });

      this.updateDomain(true);
      // this.debug();
    },

    reset(forceGraph) {
      d3.select(this.$store.state.futureloadRefs.svgEmbedded).selectAll("*").remove();
      this.createGraph(forceGraph);
    },
    updateTodayLine(duration) {
      let today = this.$store.state.simulator.hoursPassed / 8;
      let todayLine = d3.select(this.$store.state.futureloadRefs.svgEmbedded).select(".todayLine");

      todayLine.interrupt();
      todayLine.transition().duration(duration).attr("x1", this.x(today)).attr("x2", this.x(today)).attr("y1", -1000).attr("y2", 1000);
    },

    toastZoomedError() {
      if (new Date() - this.lastZoomError > 7500) {
        this.$toast.error("You have to pause before further examining the future load graph", { position: "bottom-right", timeout: 7500 });
        this.lastZoomError = new Date();
      }
    },

    updateGraphPossibility() {
      var paused = this.$store.state.manuallyPaused;

      if(this.zoom == null){
        return
      }

      if (paused) {
        this.zoom.on("zoom", this.zoomedFunction);
      } else {
        this.zoom.on("zoom", this.toastZoomedError);
      }
    },

    async requestFutureloadData(){
      var response = await this.$store.state.networkHandler.getFutureLoadMetrics();

      var currentCapacities = this.$store.state.simulator.resourcePool.getCurrentCapacities();
      var data = this.parseData(response.loads, currentCapacities);

      return data;
    },

    async debug(){
      this.futureloadData = await this.requestFutureloadData();
      
    },

    formatData(data){
      var formattedData = Array.from(
        d3.group(data, (d) => d.group),
        ([key, value]) => ({ key, value })
      );

      

      return formattedData;
    },

    updateDomainFromGantt(domain, duration) {
      if (this.updateDomain == null) {
        return;
      }

      if(this.$store.state.futureloadRefs.svgEmbedded == null){
        return;
      }

      var context = d3.select(".contextEmbedded");
      if(context._groups[0][0] == null){
        return;
      }

      d3.select("rect.selection").style("fill", "steelblue").style("stroke", "steelblue");
      this.syncedGraph = true;

      var left = domain[0];
      var right = this.$store.state.simulator.params.simulationMaxDurationDays - domain[1];
      var total = this.$store.state.simulator.params.simulationMaxDurationDays;

      var leftPercent = left / total;
      var rightPercent = right / total;


      var newLeft = this.x.range()[0] + leftPercent * (this.x.range()[1] - this.x.range()[0]);
      var newRight = this.x.range()[1] - rightPercent * (this.x.range()[1] - this.x.range()[0]);

      this.x.domain(domain);
      this.updateDomain(duration != 0);
      var width = d3.select(this.$store.state.futureloadRefs.svgEmbedded).node().parentNode.clientWidth - this.margin.left - this.margin.right;

      d3.select(".focusEmbedded").select(".axis--x-embedded").interrupt();
      d3.select(".focusEmbedded").select(".axis--x-embedded").transition().ease(d3.easeLinear).duration(duration).call(this.xAxis);

      context.select(".brushEmbedded").transition().ease(d3.easeLinear).duration(duration).call(this.brush.move, [newLeft, newRight]);
    },

    async createGraph(forceGraph) {
      
      // Check if the graph should be rendered
      if (!this.showgraph() && !forceGraph) {
        this.loading = false;
        return;
      }

      //Setup some variables
      var first = true;
      var self = this;
    
      var svgEmbedded = d3.select(this.$store.state.futureloadRefs.svgEmbedded);
      var width;
      var height;
      var height2;

      //Create the axis
      self.x = d3.scaleLinear();
      var x2 = d3.scaleLinear();
      self.y = d3.scaleLinear();
      var y2 = d3.scaleLinear();
      self.xAxis = d3.axisBottom(self.x);
      var xAxis2 = d3.axisBottom(x2);
      var yAxis = d3.axisLeft(self.y);

      //Create the zoom and brush
      self.brush = d3.brushX().on("brush end", brushed);

      //Setup the line functions
      var line1 = d3
        .line()
        .x(function (d) {
          return self.x(d.day);
        })
        .y(function (d) {
          return self.y(d.load);
        });

      var line2 = d3
        .line()
        .x(function (d) {
          return x2(d.day);
        })
        .y(function (d) {
          return y2(d.load);
        });
      
      var clipRect = svgEmbedded
        .append("defs")
        .append("clipPath")
        .attr("id", "clip" + this.id)
        .append("rect");

      var focusViewPort = svgEmbedded.append("g");

      var focus = focusViewPort.append("g").attr("class", "focusEmbedded");
      var zoomFrame = svgEmbedded.append("rect").attr("class", "zoomEmbedded");

      var focusX = focus.append("g").attr("class", "axis axis--x-embedded");
      var focusY = focus.append("g").attr("class", "axis axis--y-embedded");

      var context = svgEmbedded.append("g").attr("class", "contextEmbedded");
      var contextX = context.append("g").attr("class", "axis axis--x-embedded");

      var brushG;

      this.futureloadData = await this.requestFutureloadData();


      var sumstat = Array.from(
        d3.group(this.futureloadData, (d) => d.group),
        ([key, value]) => ({ key, value })
      );

      //Setup the domains
      self.x.domain([0, self.$store.state.simulator.params.simulationMaxDurationDays]);

      self.y.domain([
        Math.min(
          -2.5,
          d3.min(this.futureloadData, function (d) {
            return d.load;
          })
        ),
        Math.max(
          1.5,
          parseFloat(
            d3.max(this.futureloadData, function (d) {
              return d.load;
            })
          ) + 0.1
        ),
      ]);

      
      //Setup the lines and labels
      var yAxisLine = focus.append("line").attr("x1", self.x(-10000)).attr("y1", self.y(0)).attr("x2", self.x(10000)).attr("y2", self.y(0)).attr("stroke-width", 4).attr("stroke", "#4358C0").attr("clip-path", `url(#clip${this.id})`);

      var todayLine = focus.append("line").attr("x1", self.x(0)).attr("y1", self.y(-1000)).attr("x2", self.x(0)).attr("y2", self.y(1000)).attr("stroke-width", 2).attr("stroke", "#4358C0").attr("clip-path", `url(#clip${this.id})`).attr("class", "todayLine");
      var zeroLine = focus.append("line").attr("x1", self.x(0)).attr("y1", self.y(-1000)).attr("x2", self.x(0)).attr("y2", self.y(1000)).attr("stroke-width", 2).attr("stroke", "#222222").attr("clip-path", `url(#clip${this.id})`).attr("class", "zeroLine");
      var endLine = focus.append("line").attr("x1", self.x(self.$store.state.simulator.params.simulationMaxDurationDays)).attr("y1", self.y(-1000)).attr("x2", self.x(self.$store.state.simulator.params.simulationMaxDurationDays)).attr("y2", self.y(1000)).attr("stroke-width", 2).attr("stroke", "#222222").attr("clip-path", `url(#clip${this.id})`).attr("class", "endLine");

      var yAxisLabel = focus.append("text").attr("class", "y label").attr("text-anchor", "middle").attr("y", -60).attr("dy", ".75em").attr("transform", "rotate(-90)").text("Load (workhours per hour)").attr("style", "fill: gray; font-size: 1.3em;");
      var xAxisLabel = focus.append("text").attr("class", "x label").attr("text-anchor", "middle").attr("dy", ".75em").text("Days").attr("style", "fill: gray; font-size: 1.3em;");
      var xAxisLabel2 = focus.append("text").attr("class", "x label").attr("text-anchor", "middle").attr("dy", ".75em").text("Days").attr("style", "fill: gray; font-size: 1.3em;");

      sumstat.forEach((lineData) => {
        var focusLine = focus
          .append("path")
          .datum(lineData.value)
          .attr("class", "line line" + lineData.key) // I add the class line to be able to modify this line later on.
          .attr("fill", "none")
          .attr("stroke", this.colorMapper[lineData.key])
          .attr("stroke-width", 2)
          .attr(
            "d",
            d3
              .line()
              .x(function (d) {
                return self.x(d.day);
              })
              .y(function (d) {
                return self.y(d.load);
              })
          )
          .attr("clip-path", `url(#clip${this.id})`);

        if (first) {
          focusLine.transition().duration(self.$store.state.visualiser.params.duration).attr("opacity", 1);
        }
        var contextPath = context
          .append("path")
          .datum(lineData.value)
          .attr("class", "line") // I add the class line to be able to modify this line later on.
          .attr("fill", "none")
          .attr("stroke", this.colorMapper[lineData.key])
          .attr("stroke-width", 1)
          .attr("clip-path", `url(#clip${this.id})`)

          .attr(
            "d",
            d3
              .line()
              .x(function (d) {
                return self.x(d.day);
              })
              .y(function (d) {
                return self.y(d.load);
              })
          );
        this.focusPaths[lineData.key] = focusLine;
        this.contextPaths[lineData.key] = contextPath;
      });

      x2.domain(self.x.domain());
      y2.domain(self.y.domain());

      if (!brushG) brushG = context.append("g").attr("class", "brushEmbedded");

      resize();
      first = false;

      function zoomed(event) {
        // console.log(event)
        if (event.sourceEvent == null) return; // ignore zoom-by-brush

        if (self.$store.state.manuallyPaused) {
          d3.select("rect.selection").style("fill", "red").style("stroke", "red");
          self.syncedGraph = false;
        }
        // console.log("zoomed")
        var t = event.transform;

        // console.log(t)
        var domain = t.rescaleX(x2).domain();

        self.x.domain(domain);
        updateDomain(false);
        //focus.selectAll(".line").attr("d", line1);
        focus.select(".axis--x-embedded").call(self.xAxis);
        self.coupledWithGantt = true;

        context.select(".brushEmbedded").call(self.brush.move, self.x.range().map(t.invertX, t));
      }

      self.zoomedFunction = zoomed;

      function updateDomain(addDuration) {

        var filteredData = self.futureloadData//.filter((d) => d.day > self.x.domain()[0] && d.day < self.x.domain()[1] && self.$store.state.graphs.futureLoadCheckBoxes[d.group]);

       
        if (filteredData.length == 0) {
          self.y.domain([-2.5, 1.5]);
        } else {
          self.y.domain([
            Math.min(
              -2.5,
              d3.min(filteredData, function (d) {
                return d.load;
              })
            ),
            Math.max(
              1.5,
              parseFloat(
                d3.max(filteredData, function (d) {
                  return d.load;
                })
              ) + 0.1
            ),
          ]);
        }


        focusY.interrupt();
        yAxisLine.interrupt();
        zeroLine.interrupt();
        endLine.interrupt();
        focus.selectAll(".line").interrupt();

        if (addDuration) {
          focusY.transition().ease(d3.easeLinear).duration(self.$store.state.visualiser.params.duration).call(yAxis);
          focus
            .selectAll(".line")
            .transition()
            .ease(d3.easeLinear)
            .duration(100)
            .attr("d", line1)
            .attr("opacity", function (d) {
              return self.getOpacity(d[0].group);
            }); //d => 1 ? self.$store.state.graphs.futureLoadCheckBoxes[d[0].group] : 0);

          zeroLine.transition().ease(d3.easeLinear).duration(self.$store.state.visualiser.params.duration).attr("x1", self.x(0)).attr("y1", self.y(-1000)).attr("x2", self.x(0)).attr("y2", self.y(1000));
          endLine.transition().ease(d3.easeLinear).duration(self.$store.state.visualiser.params.duration).attr("x1", self.x(self.$store.state.simulator.params.simulationMaxDurationDays)).attr("y1", self.y(-1000)).attr("x2", self.x(self.$store.state.simulator.params.simulationMaxDurationDays)).attr("y2", self.y(1000));
          yAxisLine.transition().ease(d3.easeLinear).duration(self.$store.state.visualiser.params.duration).attr("x1", self.x(-10000)).attr("y1", self.y(0)).attr("x2", self.x(10000)).attr("y2", self.y(0));
          self.updateTodayLine(self.$store.state.visualiser.params.duration);
          // todayLine.transition().duration(300).attr("x1", self.x(0)).attr("y1", y(-1000)).attr("x2", self.x(0)).attr("y2", y(1000));
        } else {
          focusY.call(yAxis);
          focus
            .selectAll(".line")
            .attr("d", line1)
            .attr("opacity", function (d) {
              return self.getOpacity(d[0].group);
            });
          yAxisLine.attr("x1", self.x(-10000)).attr("y1", self.y(0)).attr("x2", self.x(10000)).attr("y2", self.y(0));
          zeroLine.attr("x1", self.x(0)).attr("y1", self.y(-1000)).attr("x2", self.x(0)).attr("y2", self.y(1000));
          endLine.attr("x1", self.x(self.$store.state.simulator.params.simulationMaxDurationDays)).attr("y1", self.y(-1000)).attr("x2", self.x(self.$store.state.simulator.params.simulationMaxDurationDays)).attr("y2", self.y(1000));
          self.updateTodayLine(0);
          // todayLine.attr("x1", self.x(0)).attr("y1", y(-1000)).attr("x2", self.x(0)).attr("y2", y(1000));
        }
      }

      this.updateDomain = updateDomain;

      function brushed(event) {
        
        // console.log(event)
        if (event.sourceEvent == null) {
          return; // ignore brush-by-zoom
        }

        if (self.$store.state.manuallyPaused) {
          d3.select("rect.selection").style("fill", "red").style("stroke", "red");
          self.syncedGraph = false;

        }
        self.coupledWithGantt = true;
        var s = event.selection || x2.range();
        var relativeSize = (self.maxZoom * self.maxZoom * (s[1] - s[0])) / width;

        if (relativeSize < self.maxZoom) {
          var diff = (width * (self.maxZoom - relativeSize)) / (self.maxZoom * self.maxZoom);

          var diffRight = diff / 2;
          var diffLeft = diff / 2;

          if (s[0] < diffLeft) {
            diffRight += diffLeft - s[0];
            diffLeft = s[0];
          }

          if (s[1] + diffRight > width) {
            var max = width - s[1];
            diffLeft += diffRight - max;
            diffRight = max;
          }
          s[0] -= diffLeft;
          s[1] += diffRight;

          context.select(".brushEmbedded").call(self.brush.move, s);
        }

        var domain = s.map(x2.invert, x2);
        // console.log(domain)
        self.x.domain(domain);
        updateDomain(false);

        //focus.selectAll(".line").attr("d", line1);
        focus.select(".axis--x-embedded").call(self.xAxis);

        // console.log("Ttt", d3.zoomIdentity.scale(width / (s[1] - s[0])).translate(-s[0], 0))

        svgEmbedded.select(".zoomEmbedded").call(self.zoom.transform, d3.zoomIdentity.scale(width / (s[1] - s[0])).translate(-s[0], 0));
      }

      self.brushedFunction = brushed;

      function resize() {
        if (self.$router.currentRoute.path != "/graphs" && !self.waitForLoad) {
          return;
        }

        if (self.$router.currentRoute.path != "/pipeline" && self.waitForLoad) {
          return;
        }

        var widthBefore = width;
        1;

        var container = svgEmbedded.node().parentNode;

        var svgWidth = container.clientWidth;
        var svgHeight = container.clientHeight;

        if (svgWidth == 0) {
          return;
        }

        svgEmbedded.attr("width", svgWidth);
        svgEmbedded.attr("height", svgHeight);

        width = svgWidth - self.margin.left - self.margin.right;
        var totalHeight = svgHeight - self.margin.top - self.margin.bottom - self.margin.between;
        height = totalHeight * 0.8;
        height2 = totalHeight * 0.2;

        if (width < 0 || height < 0) {
          return;
        }
        zoomFrame
          .attr("width", width)
          .attr("height", height)
          .attr("transform", "translate(" + self.margin.left + "," + self.margin.top + ")");

        self.x.range([0, width]);
        x2.range([0, width]);
        self.y.range([height, 0]);
        y2.range([height2, 0]);

        self.brush.extent([
          [0, 0],
          [width, height2],
        ]);

        self.xAxis.ticks(10).tickSize(-height, 0, 0);
        yAxis.ticks(5).tickSize(-width, 0, 0);
        self.zoom = d3
          .zoom()
          .scaleExtent([1, self.maxZoom])
          .translateExtent([
            [0, 0],
            [width, height],
          ])
          .extent([
            [0, 0],
            [width, height],
          ])
          .on("zoom", zoomed);
        //area.y0(height);
        //area2.y0(height2);

        clipRect.attr("width", width).attr("height", height);

        focus.attr("transform", "translate(" + self.margin.left + "," + self.margin.top + ")");
        focusX.attr("transform", "translate(0," + height + ")").call(self.xAxis);

        yAxisLabel.attr("x", svgHeight * 0.8 - 100);
        xAxisLabel.attr("x", svgWidth / 2 - 148).attr("y", svgHeight * 0.8 - 114);
        xAxisLabel2.attr("x", svgWidth / 2 - 148).attr("y", svgHeight - 96);

        focusY.call(yAxis);

        var top2 = self.margin.top + height + self.margin.between;
        context.attr("transform", "translate(" + self.margin.left + "," + top2 + ")");
        contextX.attr("transform", "translate(0," + height2 + ")").call(xAxis2);

        focus.selectAll("path.line").attr("d", line1);
        context.selectAll("path.line").attr("d", line2);
        zoomFrame.call(self.zoom);

        var brushSelection = null;
        var brushNode = context.select("g.brushEmbedded").node();
        if (brushNode) brushSelection = d3.brushSelection(brushNode);

        if (brushSelection) {
          brushSelection = brushSelection.map(function (x) {
            return x * (width / widthBefore);
          });
        } else brushSelection = self.x.range();

        if(brushSelection[1] > brushSelection[0]){
          context.select("g.brushEmbedded").call(self.brush).call(self.brush.move, brushSelection);
        }

        if (first) {
          svgEmbedded.select("g.focusEmbedded").transition().duration(self.$store.state.visualiser.params.duration).attr("opacity", 1);
          svgEmbedded.select("g.contextEmbedded").transition().duration(self.$store.state.visualiser.params.duration).attr("opacity", 1);
        }

        yAxisLine.attr("x1", self.x(-1000)).attr("y1", self.y(0)).attr("x2", self.x(1000)).attr("y2", self.y(0));
        // todayLine.attr("x1", self.x(0)).attr("y1", y(-1000)).attr("x2", self.x(0)).attr("y2", y(1000));
        
        self.updateTodayLine(0);
      }

      window.addEventListener("resize", resize);

      this.loading = false;
      this.resizeFunction = resize;
      this.$emit("loaded", this);
      updateDomain(true);
      //setInterval(resize, 100);

      first = false;
      this.updateDomainFromGantt(this.$store.state.visualiser.calculateFutureloadGraphCamera())
    
    },
    updateGraph() {
      if (this.updateDomain != null) {
        this.updateDomain(true);
      }
    },
    alterSelection() {
      for (const [key, val] of Object.entries(this.$store.state.graphs.futureLoadCheckBoxes)) {
        this.$store.state.graphs.futureLoadCheckBoxes[key] = !this.selectAll;
      }

      this.selectAll = !this.selectAll;

      this.updateGraph();
    },

    getOpacity(groupCode) {
      var returnVal = 0;
      if (this.$store.state.graphs.futureLoadCheckBoxes[groupCode]) {
        returnVal = 1;
      }
      return returnVal;
    },
    parseData(data, currentCapacities) {
      var parsedData = [];
      for (const [key, value] of Object.entries(data)) {
        for (const [loadKey, load] of Object.entries(value)) {
          parsedData.push({ day: key / 8, group: loadKey, load: load - currentCapacities[loadKey] });
        }
      }

      var finalDay = this.$store.state.simulator.params.simulationMaxDurationDays;

      if(data[finalDay * 8] == null){
        parsedData.push({ day: finalDay, group: "B", load: -currentCapacities["B"] });
        parsedData.push({ day: finalDay, group: "O", load: -currentCapacities["O"] });
        parsedData.push({ day: finalDay, group: "I", load: -currentCapacities["I"] });
        parsedData.push({ day: finalDay, group: "M", load: -currentCapacities["M"] });
        parsedData.push({ day: finalDay, group: "A", load: -currentCapacities["A"] });
        parsedData.push({ day: finalDay, group: "P", load: -currentCapacities["P"] });
      }
      return parsedData;
    },
    showgraph() {
      return this.$store.state.simulator != null && this.$store.state.simulator.params.showGraphs && this.$store.state.simulator.params.allowPortfolioPlanning;
    },
  },
  async mounted() {
    this.$store.state.futureloadRefs = this.$refs;
    if (!this.waitForLoad) {
      this.createGraph();
    }
  },
};
</script>

<style>
.domain {
  stroke: lightgrey;
}
.tick line {
  stroke: lightgrey;
  stroke-opacity: 0.7;
  shape-rendering: crispEdges;
}

g.tick line {
  stroke: lightgrey;
  stroke-opacity: 0.7;
  shape-rendering: crispEdges;
}
.axis line {
  stroke: lightgrey;
  stroke-opacity: 0.7;
  shape-rendering: crispEdges;
}
rect.selection {
  fill: steelblue;
  stroke: steelblue;
  stroke-width: 1px;
  opacity: 1;
}
rect.zoomEmbedded {
  cursor: move;
  fill: none;
  pointer-events: all;
}
</style>

<style scoped>

.synced-color{
  position: absolute;
  left: 14px;
  width: 20px;
  height: 20px;
  margin-top: 12px;
  background-color: rgba(70, 130, 180, 0.5);

  border: 2px solid steelblue;
}
.desynced-color{
  position: absolute;
  left: 14px;
  width: 20px;
  height: 20px;
  margin-top: 12px;
  background-color: rgba(180, 70, 70, 0.5);

  border: 2px solid red;
}

.synced-legend{
  padding-top: 20px;
}

.local-container {
  width: 100%;
  height: 100%;
  z-index: 10;
  border-top: 2px solid #949494;
  border-left: 2px solid #949494;
}
.graph-name {
  position: absolute;
  width: calc(100% - 220px);
  justify-content: center;
  display: flex;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 16px;
  top: 15px;
  color: #4a4a4a;
}
.legend {
  width: 220px;
  height: 100%;
  max-width: 220px;
  background-color: #fdfdfd;
  border-left: solid 1px #dcdcdc;
  border-top: 2px solid #949494;

  font-size: 25px;
  position: absolute;
  right: 0;
  top: 0;
}
.futureloadcontainer {
  display: flex;
  width: 100%;
}
.loading-container {
  position: absolute;
  height: 560px;
  width: calc(100% - 220px);
  display: flex;
  justify-content: center;
}
.loading-sign {
  height: 560px;
  top: 220px;
}
.header {
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  font-size: 13px;
  color: #4a4a4a;
  display: flex;
  padding: 15px;
  padding-bottom: 0;
}
.selection {
  color: red;
  background-color: red;
}

.noGraphs {
  width: 100%;
  height: 100%;
  padding: 50px;
  display: flex;
  font-size: 2em;
  font-family: Helvetica, sans-serif;
  font-weight: bold;
}

.nographText {
  width: 100%;
  height: 100%;
  text-align: center;
}
.totalChart {
  width: 100%;
}
.charts {
  overflow: auto;
  height: 100%;
}

.checkBoxes {
  width: 100%;
  display: flex;
  justify-content: center;
}

.totalChartContainer {
  width: 100%;
  display: flex;
}
.chart {
  width: 100%;
  z-index: 100;
}
.zoom {
  cursor: move;
  pointer-events: all;
  color: green;
}
</style>
